import { render, staticRenderFns } from "./AppAvatarAdmin.vue?vue&type=template&id=58a96138"
import script from "./AppAvatarAdmin.vue?vue&type=script&lang=js"
export * from "./AppAvatarAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports